import React from 'react'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import PaymentDetails from '@/pages/rqCertifiedApplicationStatus/components/PaymentDetails'

interface Props {
  onHide: () => void
}

const StartApplicationModal: React.FC<Props> = ({ onHide }) => {
  return (
    <Dialog open onHide={onHide}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Payment instructions</DialogTitle>
        </DialogHeader>

        <DialogBody>
          <>
            <p className="mb-4">
              <PaymentDetails />
            </p>

            <p className="mb-4">
              We are processing your application fee payment. We will notify you
              when your payment details have been confirmed and when you can
              begin your application.
            </p>
          </>
        </DialogBody>

        <DialogFooter>
          <Button variant="outline-secondary" onClick={onHide}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default StartApplicationModal
